import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { withArtifex } from "core";
import ClientHelper from "core/ClientHelper";
import DateHelper from "core/DateHelper";
import Formatter from "core/Formatter";
import PropTypes from "prop-types";
import React from "react";
import ButtonToolbar from "views/Components/ButtonToolbar";
import { GenericDateInput, GenericPage, GenericGrid, GenericNumberInput, GenericSelectInput, GenericTextInput, GenericTitle } from "views/Components/Generic";
import LoadingComponent from "views/Components/LoadingComponent";
import ParameterComponent from "views/Components/ParameterComponent";
import { GridColumnType } from "views/Constants/Constant";

class OverlimitTransactionTrail extends GenericPage {
	constructor(props) {
		super(props);

		this.isBackOffice = ClientHelper.IsBackOffice();
		this.clientId = ClientHelper.GetClientId();

		this.defaultModel = {
			UniqueClientId: this.isBackOffice ? undefined : this.clientId,
			StartDate: DateHelper.GetDate(),
			EndDate: DateHelper.GetDate(),
			TrxDirection: undefined,
			MessageType: undefined,
			FromAmount: undefined,
			ToAmount: undefined,
			BeneficiaryName: undefined
		};

		this.state = {
			model: { ...this.defaultModel }
		};

		this.EmptyObject = {};
		this.columns = [
			{
				Header: "Client Name",
				accessor: "ClientName"
			},
			{
				Header: "Beneficiary Name",
				Cell: row => (<span>{row.original.BeneficiaryCompanyName == "" ? row.original.BeneficiaryName : row.original.BeneficiaryCompanyName}</span>)
			},
			{
				Header: "Template Name",
				accessor: "TemplateName",
			},
			{
				Header: "Date Of Request",
				accessor: "DateOfRequest",
				type: GridColumnType.Date

			},
			{
				Header: "Value Effective",
				accessor: "ValueEffective",
				type: GridColumnType.Date

			},
			{
				Header: "Amount",
				accessor: "Amount",
				Cell: row => (<span>{Formatter.FormatDecimal(row.value)}</span>)
			},
			{
				Header: "Status",
				accessor: "Status"
			},
			{
				Header: "Sub-Status",
				accessor: "SubStatus"
			},
			{
				Header: "Destination",
				accessor: "DestinationCountry"
			}
		];

	}

	componentDidMount() {
		super.componentDidMount();
		this.Bind(this);
		const { setAppLeftTitle, setAppCenterTitle } = this.props;

		if (setAppLeftTitle)
			setAppLeftTitle("Overlimit Transaction Trail");
		if (setAppCenterTitle)
			setAppCenterTitle("WIRE TRANSFER");
	}

	SearchClick() {
		const { model } = this.state;

		this.ExecutePostRequest("/bankapi/v1.0/WireTransfer/SearchOverlimitTransactionTrail",
			model,
			responseData => {
				this.setState({ Data: responseData.Item });
			});
	}

	ClearClick() {
		this.setState({ model: { ...this.defaultModel } });
	}

	ValueChanged(name, newValue) {
		this.setState(state => {
			var model = state.model || {};
			model[name] = newValue;

			return { model };
		});
	}

	render() {
		const { Disabled } = this.props;
		const { model, Data } = this.state;
		const { IsLoading, Alert } = this.state;

		return (
			<>
				{Alert}
				<LoadingComponent Show={IsLoading} />
				<ButtonToolbar ButtonList={[
					{ Code: "Search", OnClick: this.SearchClick, Disabled: Disabled },
					{ Code: "Clear", OnClick: this.ClearClick, Disabled: Disabled }
				]} menuId={this.props.menuId} ApprovalData={this.props.ApprovalData} After={this.props.After} />
				<Card>
					<CardHeader>
						<GenericTitle text={"Filter Panel"} />
					</CardHeader>
					<CardBody>
						<GridContainer>
							<GridItem xs={4}>
								<GenericSelectInput
									Name="UniqueClientId"
									LabelText={"Client Name"}
									Value={model.UniqueClientId}
									DataRoot="Item"
									ValueChanged={this.ValueChanged}
									KeyValueMember="UniqueClientId"
									TextValueMember="Name"
									Url="/bankapi/v1.0/BankCustomer/Search"
									CanClear
									Method="POST"
									Disabled={Disabled || !this.isBackOffice}
									Parameter={this.EmptyObject} />
								<GenericDateInput Name="StartDate" LabelText={"From Date"} Value={model.StartDate}
									Utc={true}
									ValueChanged={this.ValueChanged} Disabled={Disabled} />

								<GenericDateInput Name="EndDate" LabelText={"To Date"} Value={model.EndDate}
									Utc={true}
									ValueChanged={this.ValueChanged} Disabled={Disabled} />
							</GridItem>
							<GridItem xs={4}>
								<GenericNumberInput Name="FromAmount" LabelText={"From Amount"} Value={model.FromAmount} ValueChanged={this.ValueChanged} Disabled={Disabled} />
								<GenericNumberInput Name="ToAmount" LabelText={"To Amount"} Value={model.ToAmount} ValueChanged={this.ValueChanged} Disabled={Disabled} />
							</GridItem>
						</GridContainer>
					</CardBody>
				</Card>
				<GenericGrid
					Data={Data}
					Columns={this.columns}
				/>
			</>
		);
	}
}

OverlimitTransactionTrail.propTypes = {
	classes: PropTypes.object.isRequired,
	Disabled: PropTypes.bool,
	ValueChanged: PropTypes.func,
	Model: PropTypes.object
};

export default withArtifex(OverlimitTransactionTrail, {});